import React from 'react'

function LegalNotice() {
  return (
    <div className="bg-background-secondary-color rounded-lg p-6 font-popins mt-5 lg:m-[100px]">
      <h2 className="text-3xl font-extrabold text-btn-color mb-10">Legal Notice</h2>
      <div className="space-y-8 max-w-4xl">

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Introduction</h3>
            <p className="text-sm text-white mt-4">
              This **Legal Notice** governs your use of the website <span className="text-btn-color font-bold">FinzAid.com</span>. By accessing or using our services, you agree to comply with the terms and conditions outlined in this notice. These terms apply to all visitors, users, and others who access or use the website. If you do not agree to these terms, you must cease using the site immediately.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Intellectual Property</h3>
            <p className="text-sm text-white mt-4">
              All content published on <span className="text-btn-color font-bold">FinzAid.com</span>, including but not limited to text, images, videos, graphics, and audio, is the exclusive property of FinzAid or its licensors. The unauthorized use, distribution, or reproduction of this content is strictly prohibited without prior written permission from FinzAid. This includes, but is not limited to, copying, downloading, or redistributing our content for commercial or personal use.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Liability Disclaimer</h3>
            <p className="text-sm text-white mt-4">
              The content on <span className="text-btn-color font-bold">FinzAid.com</span> is provided for informational purposes only and does not constitute financial or legal advice. We make no warranties or representations about the accuracy, completeness, or reliability of any content on the website. By using our site, you acknowledge that any reliance on such content is at your own risk. FinzAid will not be held liable for any losses or damages arising from the use or misuse of the information provided on our site.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">User Responsibilities</h3>
            <p className="text-sm text-white mt-4">
              Users of <span className="text-btn-color font-bold">FinzAid.com</span> are responsible for ensuring that their use of the website complies with all applicable laws and regulations. You agree not to engage in any illegal, harmful, or disruptive behavior while using our services. FinzAid reserves the right to suspend or terminate access to the website without notice if users are found to be in violation of these terms.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Governing Law</h3>
            <p className="text-sm text-white mt-4">
              This **Legal Notice** shall be governed and construed in accordance with the laws of the jurisdiction in which FinzAid operates, without regard to its conflict of law provisions. Any disputes arising out of or related to the use of <span className="text-btn-color font-bold">FinzAid.com</span> shall be resolved through the courts located in the jurisdiction of FinzAid's principal place of business.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Changes to the Legal Notice</h3>
            <p className="text-sm text-white mt-4">
              FinzAid reserves the right to update or modify this **Legal Notice** at any time. Users are encouraged to review this page periodically to stay informed of any changes. Continued use of <span className="text-btn-color font-bold">FinzAid.com</span> after any modifications to the notice will constitute acceptance of the revised terms.
            </p>
          </div>
        </div>

      </div>
    </div>
  )
}

export default LegalNotice;
